import React from 'react';
import { CustomerBView } from './customer-b';
import { CustomerB2View } from './customer-b2';
import { CustomerCView } from './customer-c';

type CustomerVariant = 'b' | 'b2' | 'c';

const normalizePathname = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

const getPageQuery = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return new URLSearchParams(window.location.search).get('page');
  } catch {
    return null;
  }
};

const isVariantPath = (pathname: string, variant: CustomerVariant): boolean => {
  const normalized = normalizePathname(pathname);
  const base = `/customer/${variant}`;
  return normalized === base || normalized.startsWith(`${base}/`);
};

const isVariantQuery = (variant: CustomerVariant): boolean => {
  const page = getPageQuery();
  return page === `customer/${variant}` || Boolean(page?.startsWith(`customer/${variant}/`));
};

export const isCustomerPath = (pathname: string): boolean =>
  isVariantPath(pathname, 'b') || isVariantPath(pathname, 'b2') || isVariantPath(pathname, 'c');

export const hasCustomerPageQuery = (): boolean =>
  isVariantQuery('b') || isVariantQuery('b2') || isVariantQuery('c');

export const CustomerView: React.FC = () => {
  const pathname = typeof window === 'undefined' ? '/customer/b' : window.location.pathname;
  if (isVariantPath(pathname, 'b2') || isVariantQuery('b2')) {
    return <CustomerB2View />;
  }

  if (isVariantPath(pathname, 'c') || isVariantQuery('c')) {
    return <CustomerCView />;
  }

  return <CustomerBView />;
};

export default CustomerView;
